<template>
  <section class="myhome-con"
           v-if="isInit">
    <div class="tit-box type1">
      <h1 class="tit-type1">1:1 문의</h1>
    </div>
    <div class="search-box">
      <cd-selbx :title="'분류'"
                :is-all="true"
                :cds="dirctInqryTycds"
                :cd="dirctInqryTycd"
                @select="selbxDirctInqryTycd_select"/>
      <cd-selbx :title="'조회조건'"
                :cds="$cmmn.txt.srchs"
                :cd="srchSe"
                :cd-txt="'se'"
                @select="selbxSrchSe_select"/>
      <input type="text"
             class="txt mgl5"
             style="width:150px;"
             v-model="srwd"
             @keyup.enter="btnSrch_click"/>
      <btn :txt="'검색'"
           :size="'middle'"
           :color="'gray'"
           @click="btnSrch_click"/>
    </div>
    <div class="tit-box type2 mgt0">
      <btn :txt="'문의하기'"
           :size="'middle'"
           :color="'purple'"
           @click="btnInqry_click"/>
    </div>
    <table class="tb-col">
      <colgroup>
        <col style="width:6%;" />
        <col style="width:10%;" />
        <col style="width:15%;" />
        <col style="width:auto;" />
        <col style="width:10%;" />
        <col style="width:10%;" />
        <col style="width:12%;" />
      </colgroup>
      <thead>
      <tr>
        <th>번호</th>
        <th>분류</th>
        <th>어린이집명</th>
        <th>제목</th>
        <th>접수상태</th>
        <th>첨부파일</th>
        <th class="last">등록일</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="{rno, bbstSn, dirctInqryTynm, rqtFcltyNm, bbstSj, dirctInqryPrgrStnm, tchFileCnt, rgstDttm} in dirctInqrys"
          :key="bbstSn">
        <td>{{ paging.totCnt - rno + 1 }}</td>
        <td>{{ dirctInqryTynm }}</td>
        <td>{{ rqtFcltyNm }}</td>
        <td class="__left">
          <a href="javascript:;"
             @click="txtBbstSj_click(bbstSn)">{{ bbstSj }}</a>
        </td>
        <td>{{ dirctInqryPrgrStnm }}</td>
        <td>
          <div v-if="tchFileCnt > 0"
               class="img-com icon-etc"><span>첨부파일</span></div>
        </td>
        <td class="last">{{ rgstDttm.substring(0, 10) }}</td>
      </tr>
      <tr v-if="dirctInqrys.length == 0">
        <td class="last" colspan="7">조회 된 1:1 문의 목록이 없습니다.</td>
      </tr>
      </tbody>
    </table>
    <pagination v-if="paging.totCnt > paging.listCnt"
                :paging="paging"
                @move-page="movePage"/>
  </section>
</template>

<script setup>
import {defineEmits, onMounted, ref, defineProps} from "vue";

import {getUtils, getStore} from "@/utils/import";
const {$cmmn, $axios, $cd} = getUtils();
const {$mber, $loading} = getStore();

const props = defineProps({
  fcltySn: Number
});

const dirctInqryTycds = ref([]);
const dirctInqryTycd = ref('');
const srchSe = ref('001');
const srwd = ref('');

const dirctInqrys = ref([]);
const paging = ref({
  listCnt: 9,
  pageCnt: 5,
  nowPageNo: 1,
  totCnt: 0,
})


const getDirctInqrys = async () => {
  const {listCnt, nowPageNo} = paging.value;

  const params = {
    rqtMberSn: $mber.mberSn,
    dirctInqryTycd: dirctInqryTycd.value,
    srchSe: srchSe.value,
    srwd: srwd.value,
    paging: {
      listCnt,
      nowPageNo
    }
  }

  if (props.fcltySn) params.rqtFcltySn = props.fcltySn;

  const {data} = await $axios.get('/api/cscr/dirct-inqrys?' + $cmmn.txt.createQueryStr(params));
  dirctInqrys.value = data.dirctInqrys;
  paging.value.totCnt = data.paging.totCnt;
}

const selbxDirctInqryTycd_select = (selCd) => {
  dirctInqryTycd.value = selCd;
}

const selbxSrchSe_select = (selCd) => {
  srchSe.value = selCd;
}

const btnSrch_click = async () => {
  try {
    $loading.on();

    paging.value.nowPageNo = 1;
    await getDirctInqrys();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const btnInqry_click = () => {
  emits('chng-mode', {mode: 'register'});
}

const movePage = async (pageNo) => {
  try {
    $loading.on();

    paging.value.nowPageNo = pageNo;
    await getDirctInqrys();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const emits = defineEmits(['chng-mode'])
const txtBbstSj_click = (bbstSn) => {
  emits('chng-mode', {mode: 'dp', bbstSn});
}

const isInit = ref(false);
const init = async () => {
  const [cds] = await Promise.all([$cd.getCmmnCds('CMM1026'), getDirctInqrys()]);
  dirctInqryTycds.value = cds;

  isInit.value = true;
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
